import {Text} from "@gs-ux-uitoolkit-react/text";
import {Form, FormFeedback, FormControl} from "@gs-ux-uitoolkit-react/form";
import {Button} from "@gs-ux-uitoolkit-react/button";
import React, {useState, useEffect, useCallback} from "react";
import {Radio} from "@gs-ux-uitoolkit-react/radio";
import {LoadingIcon} from "@gs-ux-uitoolkit-react/loading";
import {useForgotPasswordContext} from "../context/ForgotPasswordContextProvider";

export function ForgotPasswordContinuationForm() {

    const [busy, setBusy] = useState(false);
    const [mfaMethod1, setMfaMethod1] = useState("");
    const {forgotPasswordAttempt, updateForgotPasswordSendMfa} = useForgotPasswordContext();

    const handleContinue = useCallback(async () => {
        try {
            setBusy(true);
            await updateForgotPasswordSendMfa(mfaMethod1);
        } finally {
            setBusy(false);
        }
    }, [mfaMethod1, setMfaMethod1])


    return (
        <div className="flex flex-col items-stretch gap-6 w-full">
            <Text typography="textTitle02" data-qa-comp="reset-password-title">Reset your password</Text>
            <Text typography="textBody01Medium" color="colorTextNeutralBold">
                To help verify your identity and keep your information secure, we require MFA verification. Choose a verification method:
            </Text>
            <Text typography="textBody02Regular">
                Check your 'Spam' or 'Unknown Senders' folder if the SMS code does not arrive shortly.
            </Text>
            <FormControl>
                {
                    forgotPasswordAttempt?.maskedDayPhoneNumber && <div className="flex flex-col gap-4">
                        <div className="flex flex-col gap-2">
                            <Text typography="textBody01Regular" color="colorTextNeutralBold">Text</Text>
                            <div className="flex flex-col gap-2 pl-2">
                                <Radio name="mfaradio" size="md" onClick={() => {setMfaMethod1("daySms")}} >
                                    {forgotPasswordAttempt.maskedDayPhoneNumber}
                                </Radio>
                                { forgotPasswordAttempt?.maskedEveningPhoneNumber && <Radio name="mfaradio" size="md" onClick={() => {setMfaMethod1("eveningSms")}} >
                                    {forgotPasswordAttempt.maskedEveningPhoneNumber}
                                </Radio> }
                            </div>
                        </div>

                        <div className="flex flex-col gap-2">
                            <Text typography="textBody01Regular" color="colorTextNeutralBold">Call</Text>
                            <div className="flex flex-col gap-2 pl-2">
                                <Radio name="mfaradio" size="md" onClick={() => {setMfaMethod1("dayCall")}} >
                                    {forgotPasswordAttempt.maskedDayPhoneNumber}
                                </Radio>
                                { forgotPasswordAttempt?.maskedEveningPhoneNumber && <Radio name="mfaradio" size="md" onClick={() => {setMfaMethod1("eveningCall")}} >
                                    {forgotPasswordAttempt.maskedEveningPhoneNumber}
                                </Radio> }
                            </div>
                        </div>
                    </div>
                }
            </FormControl>

            <Button
                className="w-full"
                size="md"
                appearance="highlight"
                emphasis="bold"
                type="submit"
                onClick={handleContinue}
                disabled={!mfaMethod1 || busy}
                data-qa-comp="continue-button"
            >
                {!busy ? 'Continue' : <LoadingIcon size="sm"/>}
            </Button>
        </div>
    );
}